
"use strict";

import { BXDataList, BXDataListAjax} from "./../../core/bxdatalist";
import { LoggerController } from "./../../core/logger";


class BXDataListController extends LoggerController{
    static get $inject(){ return ['$log']}
    constructor($log){
        super($log);
        this.pager = new BXDataList(2);
    }

    $onInit() {
  
        if(!this.pageSize){
            this.pageSize = 2;
        }
        
        this.pager.pageSize = this.pageSize;
        this.list =  this.pager.items;

        
    }

    set model(value){
        this._model = value;
        if (typeof value === 'object'){
            var items = []; 
            for (const key in value) {
                if (value.hasOwnProperty(key)) {
                    const element = value[key];
                    items.push(element);
                }
            }
            this.pager.items = items;
        }else{
            this.pager.items = this._model;
        }

        this.list =  this.pager.items;
       
    }

 
    toPage(page){
        if(this.pager.currentPage==page){
            return ;
        }
        this.pager.currentPage = page;
        this.list =  this.pager.items;
    }


    set order(value){
        let isChanged = !!this.pager.order &&  (this.pager.order!=value);
        
        this.pager.order = value
        if(isChanged){
           
            this.pager.currentPage = 1;
            this.list =  this.pager.items;
         }
    }

    get order(){
        return this.pager.order;
    }

    set orderBy(value){
        let isChanged = !!this.pager.orderBy &&  (this.pager.orderBy!=value);
       
        this.pager.orderBy = value

        if(isChanged){
           
            this.pager.currentPage = 1;
            this.list =  this.pager.items;
        }
    }

    get orderBy(){
       return this.pager.orderBy
    }

    get filter(){
        return this.pager.filterPtr ; 
    }
    set filter(value){
       
        this.pager.filterPtr = value;

    }

    get filterExpression(){
        return this.pager.filterExpr ; 
    }
    set filterExpression(value){
        //let isChanged = !!this.pager.filterExpr &&  (this.pager.filterExpr!=value);
        this.pager.filterExpr = value;

        this.pager.currentPage = 1;
            this.list =  this.pager.items;

        /*if(isChanged){
           
            this.log('changed');
        }*/

    }

}



class BXDataListComponent {
    constructor() {
        this.template   = require("./paginations.html");
        this.controller = BXDataListController;
        this.bindings   ={  
            model: '<',
            list: '=',
            pageSize: '@',
            order:'=?',
            orderBy:'=?',
            filter:'=?',
            filterExpression:'=?'
        }
    }
}



class BXDataListAjaxController extends LoggerController{
    static get $inject(){ return ['$log']}
    constructor($log){
        super($log);
        this.pager = new BXDataListAjax(2);
    }

    $onInit() {
  
        console.log('BXDataListAjaxController::onInit', this);

        if(!this.pageSize){
            this.pageSize = 2;
        }
        
        this.pager.pageSize = this.pageSize;
        this.list =  [];
        this.load();
        
    }

    set model(value){
        this._model = value;

    }

 
    toPage(page){
        
        console.log('BXDataListAjaxController::toPage');

        if(this.pager.currentPage==page){
            return ;
        }

        this.pager.currentPage = page;
        this.load();
      
    }


    set order(value){

        console.log('BXDataListAjaxController::order', value);

        let isChanged = !!this.pager.order &&  (this.pager.order!=value);
        
        this.pager.order = value
        if(isChanged){
           
            this.pager.currentPage = 1;
            this.load();
         }
    }

    get order(){
        return this.pager.order;
    }

    set orderBy(value){

        console.log('BXDataListAjaxController::orderBy', value);

        let isChanged = !!this.pager.orderBy &&  (this.pager.orderBy!=value);
       
        this.pager.orderBy = value

        if(isChanged){
           
            this.pager.currentPage = 1;
            this.list =  this.pager.items;
        }

    }

    get orderBy(){
       return this.pager.orderBy
    }

    get filter(){
        return this.pager.filterPtr ; 
    }
    set filter(value){
       
        console.log('BXDataListAjaxController::filter', value);
        this.pager.filterPtr = value;

    }

    get filterExpression(){
        return this.pager.filterExpr ; 
    }
    set filterExpression(value){

        console.log('BXDataListAjaxController::filterExpression', value);
        //let isChanged = !!this.pager.filterExpr &&  (this.pager.filterExpr!=value);
        this.pager.filterExpr = value;

        this.pager.currentPage = 1;
      
        this.load();

    }

    load(){
        
        if(!this.loader){
            return;
        }

        this.preLoader = false;



        this.loader(this.pager.currentPage, this.pager.__pageSize, this.pager.filterExpr , this.pager.order, this.pager.orderBy ).then((result)=>{
            this.pager.totalItems = result.total
            this.list = result.items;
            this.pager.calcPager();
            this.preLoader = true;
            console.log('BXDataListAjaxController loader ', result);
        })
    }

}
class BXDataListAjaxComponent {
    constructor() {
        this.template   = require("./paginations.html");
        this.controller = BXDataListAjaxController;
        this.bindings   ={  
            model: '<',
            list: '=',
            pageSize: '@',
            order:'=?',
            orderBy:'=?',
            filter:'=?',
            filterExpression:'=?',
            loader:'=',
            preLoader:'=',
        }
    }
}


export {BXDataListComponent, BXDataListAjaxComponent};








// WEBPACK FOOTER //
// ./src/components/pagination/pagination.module.js